/** Shown while CMS API is being tried (avoids fallback-then-replace flicker). */
export default function CmsPageLoader({ label = "Loading…" }) {
  return (
    <div
      className="flex min-h-[75vh] items-center justify-center bg-[#FAF8F3] px-4"
      aria-live="polite"
      aria-busy="true"
    >
      <p className="text-sm font-medium text-[#4a5568]">{label}</p>
    </div>
  );
}
